import { Alert, Box, LinearProgress, Stack } from '@mui/material'
import {
  DataGrid,
  GridToolbar,
  GridToolbarContainer,
  GridToolbarExport,
} from '@mui/x-data-grid'
import React from 'react'
import CustomToolbar from './CustomToolbar'
import NoRowsOverlay from './NoRowsOverlay'

// onPrint/printLabel are our own toolbar props - destructured so the spread
// doesn't forward them to the DOM via DataGrid.
const CustomDataGrid = ({ onPrint, printLabel, ...props }) => (
  <DataGrid
    {...props}
    // disableColumnResize={true}
    // autoHeight
    sx={{
      '& .MuiDataGrid-cell': {
        display: 'flex',
        alignItems: 'center',
      },
      '& .MuiDataGrid-columnHeaderTitle': {
        whiteSpace: 'normal',
        lineHeight: 'normal',
        textAlign: 'center',
      },
      '& .MuiDataGrid-columnHeaderTitleContainerContent .MuiCheckbox-root': {
        color: 'white',
      },
      '.MuiDataGrid-cell:focus': {
        outline: 'none',
      },
      '& .MuiDataGrid-columnHeader': {
        backgroundColor: props.color
          ? `${props.color}.main`
          : 'greycontrast.main',
        color: props.color
          ? `${props.color}.contrastText`
          : 'greycontrast.contrast.Text',
      },
      '& .MuiDataGrid-row:hover': {
        cursor: 'pointer',
      },
      border: 0,
      '& .MuiDataGrid-toolbar': {
        border: 'none',
      },
      '& .MuiDataGrid-toolbarContainer': {
        paddingTop: '8px',
        alignItems: 'center',
      },
      '& .MuiDataGrid-main': {
        border: 2,
        borderColor: props.color
          ? `${props.color}.main`
          : 'greycontrast.contrastText',
        borderRadius: '5px',
      },
      '& .MuiDataGrid-root': {
        borderRadius: 0,
      },
      '& .MuiDataGrid-columnHeadersInner': {
        backgroundColor: `${props.color ?? 'primary'}.main`,
        color: 'primary.contrastText',
        zIndex: 1,
      },
      '& .MuiDataGrid-sortIcon': {
        opacity: 1,
        color: `${props.color ?? 'primary'}.contrastText`,
      },
      '& .MuiDataGrid-menuIconButton': {
        opacity: 1,
        color: `${props.color ?? 'primary'}.contrastText`,
      },
      '& .MuiDataGrid-columnHeaders': {
        borderRadius: '0px 0px 0 0',
      },
      '& .MuiDataGrid-filterForm': {
        flexDirection: 'column',
      },
      '& .MuiDataGrid-columnSeparator': {
        opacity: 0,
        transition: 'opacity 0.2s ease-in-out',
      },
      '& .MuiDataGrid-columnHeaders:hover .MuiDataGrid-columnSeparator': {
        opacity: 1,
      },
      ...props.sx,
    }}
    slots={{
      toolbar: props?.hideToolbar
        ? null
        : () => (
            <CustomToolbar
              rows={props.rows}
              columns={props.columns}
              columnVisibilityModel={props.columnVisibilityModel}
              printOptions={props.slotProps?.toolbar?.printOptions}
              documentTitle={props.documentTitle}
              hideFilters={props.hideFilters}
              csvOptions={props.slotProps?.toolbar?.csvOptions}
              onPrint={onPrint}
              printLabel={printLabel}
            />
          ),
      loadingOverlay: LinearProgress,
      noRowsOverlay: () => (
        <NoRowsOverlay customButton={props?.norowsoverlay} />
      ),
      noResultsOverlay: () => (
        <Alert sx={{ zIndex: 10 }} severity="warning">
          No Results Found
        </Alert>
      ),
      ...props.slots,
    }}
    slotProps={{
      ...props.slotProps,
      panel: {
        sx: {
          '& .MuiDataGrid-panelWrapper': {
            maxWidth: 'calc(100vw - 4rem)',
          },
          '& .MuiOutlinedInput-root': {
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '4px',

            '& .MuiInputAdornment-root': {
              marginRight: '4px',
            },

            '& input': {
              paddingLeft: '4px',
            },
          },
        },
      },
    }}
  />
)

export default CustomDataGrid
